import template from '../../home-safety-solution.module.scss';
import Image from 'next/image';
import animations from '@styles/animations.module.scss'
import { InView } from 'react-intersection-observer';
import style from './preview-section.module.scss';

interface PreviewSectionProps {
    title: string;
    subtitle: string;
    image: string;
    text: Array<string>;
}

const PreviewSection = ({ title, subtitle, image, text }: PreviewSectionProps) => {
    return (
        <section className={`${template.section_first}`}>
            <div className={`${template.container} ${template.container_small}`}>
            <InView triggerOnce={true}>
                    {({ inView, ref, entry }: any) => {
                        if (inView) {
                            entry.target.classList.add(animations.active);
                        }
                        return (
                            <h1 ref={ref} className={`${animations.scroll__animation} ${template.title} ${template.title_large} ${template.text_align_center} ${template.margin_bot24px}`}>
                                {title}
                            </h1>
                        )
                    }}
                </InView>
            </div>
            <div className={`${template.container}`}>
                <InView triggerOnce={true}>
                    {({ inView, ref, entry }: any) => {
                        if (inView) {
                            entry.target.classList.add(animations.active);
                        }
                        return (
                            <div ref={ref} className={`${animations.scroll__animation} ${template.text} ${template.text_medium} ${template.text_align_center} ${template.margin_bot60px}`}>
                                {subtitle}
                            </div>
                        )
                    }}
                </InView>
                <InView triggerOnce={true}>
                    {({ inView, ref, entry }: any) => {
                        if (inView) {
                            entry.target.classList.add(animations.active);
                        }
                        return (
                            <div ref={ref} className={`${animations.scroll__animation} ${style.preview__image} ${template.margin_bot60px}`}>
                                <Image sizes="800px 400px 200px" src={image!} alt={title} layout={'fill'} />
                            </div>
                        )
                    }}
                </InView>
                {
                    text.map((item: string, index: number) => {
                        return (
                            <InView triggerOnce={true} key={index}>
                                {({ inView, ref, entry }: any) => {
                                    if (inView) {
                                        entry.target.classList.add(animations.active);
                                    }
                                    return (
                                        <div ref={ref} className={`${animations.scroll__animation} ${template.text} ${template.text_big} ${template.margin_bot32px}`}>
                                            {item}
                                        </div>
                                    )
                                }}
                            </InView>
                        )
                    })
                }
            </div>
        </section>
    )
}

export default PreviewSection;
